import { Container, ContentLoading } from "./styles";

export const Loading = () => {

	return (
		<Container>
			<ContentLoading />
		</Container>
	);
};